module.exports = __webpack_public_path__ + "static/media/028.c774fc6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/028.jpg
// module id = 325
// module chunks = 0